"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Thing = require("./Thing");

var _Thing2 = _interopRequireDefault(_Thing);

var _util = require("../util");

var _CommentForm = require("./CommentForm");

var _CommentForm2 = _interopRequireDefault(_CommentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NestedListing = function NestedListing(_ref) {
  var _ref$Thing = _ref.Thing,
      Thing = _ref$Thing === undefined ? _Thing2.default : _ref$Thing,
      _ref$CommentForm = _ref.CommentForm,
      CommentForm = _ref$CommentForm === undefined ? _CommentForm2.default : _ref$CommentForm,
      allChildren = _ref.allChildren,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      name = _ref.name,
      replyTo = _ref.replyTo,
      _ref$showReplyForm = _ref.showReplyForm,
      showReplyForm = _ref$showReplyForm === undefined ? false : _ref$showReplyForm,
      props = _objectWithoutProperties(_ref, ["Thing", "CommentForm", "allChildren", "className", "name", "replyTo", "showReplyForm"]);

  return [(replyTo && name === replyTo || showReplyForm) && _react2.default.createElement(CommentForm, { thingId: name, key: "replyform" }), _react2.default.createElement(
    "div",
    { className: "sitetable " + className, id: "siteTable_" + name, key: "listing" },
    (allChildren || []).map(function (thing, idx) {
      return [(0, _util.optional)(Thing, _extends({}, props, thing, { key: thing.data.id, rank: idx + 1, replyTo: replyTo })), _react2.default.createElement("div", { className: "clearleft", key: thing.data.id + "clear" })];
    })
  )];
};

exports.default = NestedListing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/NestedListing.js
// module id = 193
// module chunks = 0